<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">设备销售单</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="一级代理商名称">
                <el-input size="small" v-model="formInline.name" placeholder="昵称"></el-input>
            </el-form-item>
            <el-form-item label="款式">
                <el-select v-model="formInline.styleId" @change="styleChange" placeholder="请选择">
                        <el-option label="全部" value=""></el-option>
                        <el-option
                        v-for="item in styleList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-button size="small" type="primary" @click="search">搜索</el-button>
                <el-button size="small" @click="empty">重置</el-button>
                <el-button size="small" type="primary" @click="addClick">新增销售单</el-button>
            </el-form-item>
        </el-form>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="设备销售单" name="1"></el-tab-pane>
            <el-tab-pane label="已撤销" name="0"></el-tab-pane>
        </el-tabs>
        <el-table size="small" :data="listData" max-height="600" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column  prop="id" label="订单编号" ></el-table-column>
            <el-table-column  prop="status" label="订单状态" >
                <template slot-scope="scope">
                    <div>{{scope.row.status == 1?'创建成功':'已撤销'}}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="createdAt" label="创建时间" v-if="activeName == 1">
                <template slot-scope="scope">
                    <div>{{scope.row.createdAt|timestampToTime}}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="createdAt" label="撤销时间" v-if="activeName == 0">
                <template slot-scope="scope">
                    <div>{{scope.row.createdAt|timestampToTime}}</div>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="createName" v-if="activeName == 1" label="创建人" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="updateName" v-if="activeName == 0" label="撤销人" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="total"  label="销售设备数量" >
                <template slot-scope="scope">
                    <div>{{scope.row.total}}台</div>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip  v-if="activeName == 1" prop="price" label="每台设备售价" >
                <template slot-scope="scope">
                    <div>{{scope.row.price}}元</div>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="styleName" label="款式" ></el-table-column>
            <el-table-column show-overflow-tooltip  v-if="activeName == 1" prop="outOrderTotal" label="已创建出库单的设备数量" >
                <template slot-scope="scope">
                    <div>{{scope.row.outOrderTotal}}台</div>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="distributorName" label="一级代理商" ></el-table-column>
            <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                <el-button size="mini" type="text" v-if="scope.row.canRevoke == true" v-preventReClick @click="revokeClick(scope.$index, scope.row)">撤销</el-button>
                <el-button size="mini" type="text" v-preventReClick @click="handleEdit(scope.$index, scope.row)">查看详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 新增 -->
        <el-dialog :visible.sync="editFormVisible" width="40%" @click="closeDialog">
            <el-form label-width="200px" :model="addDeviceForm" :rules="rules" ref="addDeviceForm">
                <el-form-item label="一级代理商" prop="distributorId">
                    <el-select v-model="addDeviceForm.distributorId" placeholder="请选择">
                        <el-option
                        v-for="item in storeUsersList"
                        :key="item.id"
                        :label="item.nickname"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备数量：" prop="total">
                    <el-input size="small" v-model="addDeviceForm.total" style="width:230px" auto-complete="off" placeholder="设备数量">
                        <template slot="append">台</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="设备款式：" prop="distributorId">
                    <el-select v-model="addDeviceForm.styleId" @change="styleChange" placeholder="请选择">
                        <el-option
                        v-for="item in styleList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="每台设备售价：" prop="price">
                    <el-input size="small" v-model="addDeviceForm.price" style="width:230px" auto-complete="off" placeholder="每台设备售价">
                        <template slot="append">元</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="设置设备系统管理权限：">
                    <el-radio v-model="systemModeOperator" @input="systemModeInput" label="1">由平台设置</el-radio>
                    <el-radio v-model="systemModeOperator" @input="systemModeInput" label="2">由代理商设置</el-radio>
                </el-form-item>
                <el-form-item label="限制设备只能使用以下系统：" v-if="systemModeOperator == 1">
                    <el-checkbox v-model="systemModeRange.systemMode1" label="免费系统" ></el-checkbox>
                    <el-checkbox v-model="systemModeRange.systemMode2" label="云控桌台系统" ></el-checkbox>
                    <el-checkbox v-model="systemModeRange.systemMode3" label="共享桌台系统" ></el-checkbox>
                    <el-checkbox v-model="systemModeRange.systemMode4" label="gamebar模式" ></el-checkbox>
                </el-form-item>
                <el-form-item label="设置设备当前的系统：">
                    <el-radio v-model="systemMode" v-if="systemModeRange.systemMode1 == true" label="1">免费系统</el-radio>
                    <el-radio v-model="systemMode" v-if="systemModeRange.systemMode2 == true" label="2">云控桌台系统</el-radio>
                    <el-radio v-model="systemMode" v-if="systemModeRange.systemMode3 == true" label="3">共享桌台系统</el-radio>
                    <el-radio v-model="systemMode" v-if="systemModeRange.systemMode4 == true" label="4">gamebar模式</el-radio>
                </el-form-item>
                <el-form-item label="备注：" >
                    <el-input size="small" v-model="addDeviceForm.remark" style="width:230px" auto-complete="off" placeholder="备注"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="addDeviceSunmit('addDeviceForm')">保存</el-button>
            </div>
        </el-dialog>
        <!-- 详情 -->
        <el-dialog title="销售单详情" :visible.sync="detailsFlag" width="40%" @click="closeDialog">
            <el-descriptions class="margin-top" title="创建销售单信息" :column="2" :size="size" >
                <el-descriptions-item label="订单编号">{{StorageOrder.id}}</el-descriptions-item>
                <el-descriptions-item label="操作人">{{ StorageOrder.createName }}</el-descriptions-item>
                <el-descriptions-item label="创建时间">{{ StorageOrder.createdAt|timestampToTime }}</el-descriptions-item>
                <el-descriptions-item label="销售设备数量">{{ StorageOrder.total }}</el-descriptions-item>
                <el-descriptions-item label="款式">{{ StorageOrder.styleName }}</el-descriptions-item>
                <el-descriptions-item label="每台设备售价">{{ StorageOrder.price }}</el-descriptions-item>
                <el-descriptions-item label="一级代理商">{{ StorageOrder.distributorName }}</el-descriptions-item>
                <el-descriptions-item label="设置设备系统模式管理权限">
                    <el-tag size="small" v-if="StorageOrder.systemModeOperator == 1">由平台设置</el-tag>
                    <el-tag size="small" v-else>由经销商设置</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="限制设备只能使用以下系统">
                    <el-tag size="small" v-if="StorageOrder.systemModeRangeObject.systemMode1 == true">免费模式</el-tag>
                    <el-tag size="small" v-if="StorageOrder.systemModeRangeObject.systemMode2 == true">电控模式</el-tag>
                    <el-tag size="small" v-if="StorageOrder.systemModeRangeObject.systemMode3 == true">共享模式</el-tag>
                    <el-tag size="small" v-if="StorageOrder.systemModeRangeObject.systemMode4 == true">gamebar模式</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="设置设备当前的系统">
                    <el-tag size="small" v-if="StorageOrder.systemMode == 1">免费模式</el-tag>
                    <el-tag size="small" v-if="StorageOrder.systemMode == 2">电控模式</el-tag>
                    <el-tag size="small" v-if="StorageOrder.systemMode == 3">共享模式</el-tag>
                    <el-tag size="small" v-if="StorageOrder.systemMode == 4">gamebar模式</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="备注">{{ StorageOrder.remark }}</el-descriptions-item>

            </el-descriptions>
            <el-descriptions v-if="StorageOrder.updateName != undefined" class="margin-top" style="margin-top: 20px;" title="撤销销售单信息" :column="2" :size="size" >
                <el-descriptions-item label="操作人">{{StorageOrder.updateName}}</el-descriptions-item>
                <el-descriptions-item label="撤销时间">{{ StorageOrder.updatedAt|timestampToTime }}</el-descriptions-item>
                <el-descriptions-item label="备注">{{StorageOrder.revokeRemark}}</el-descriptions-item>
            </el-descriptions>
        </el-dialog>
        <!-- 撤销 -->
        <el-dialog title="撤销销售单单" :visible.sync="revokeFlag" width="25%" @click="closeDialog">
                <el-form :inline="true" :model="formInline" class="user-search">
                    <el-form-item label="备注">
                        <el-input size="small" v-model="remark" style="width:250px"  placeholder="备注"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="revokeFlag = false">取消</el-button>
                    <el-button size="small" type="primary" :loading="loading" class="title" @click="revokeSubmit()">保存</el-button>
                </div>
        </el-dialog>
</div>
</template>
<script>
import Pagination from '../../components/Pagination'
import { loadSaleOrderList , storeSelect , 
    createSaleOrder , getSaleOrderDetail , revokeSaleOrder , styleList} from '../../api/userMG'
export default {
    data(){
        return{
            styleList:[],
            systemModeOperator:'',
            systemModeRange:{
                systemMode1:true,
                systemMode2:true,
                systemMode3:true,
                systemMode4:true,
            },
            systemMode:'',
            storeUsersList:[],
            revokeFlag:false,
            machineList:[],
            StorageOrder:{
                systemModeRangeObject:{}
            },
            addDeviceForm:{
                distributorId:'',
                total:'',
                price:'',
                remark:'',
                styleId:'',
                styleName:''
            },
            machineIdList:[],
            id:'',
            bindingFlag:false,
            activeName:"1",
            detailsFlag:false,
            options:[
                {
                value: '1',
                label: '上架'
                }, {
                value: '0',
                label: '下架'
                },
            ],
            editForm:{},
            editFormVisible:false,
            formInline: {
                page: 1,
                limit: 10,
                styleId:'',
                name: '',
            },
            machineData:[],
            listData: [], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            remark:'',
            rules: {
                styleId : [
                { required: true, message: '请选择款式', trigger: 'blur' }
                ],
                distributorId : [
                { required: true, message: '请选择经销商', trigger: 'blur' }
                ],
                total : [
                    { required: true, message: '请输入设备数量', trigger: 'blur' },
                    { message: '格式错误',trigger: 'blur', pattern:/^[0-9]*$/}
                ],
                price : [
                { required: true, message: '请输入每台设备售价', trigger: 'blur' },
                { message: '格式错误（小数点保留两位）', trigger: 'blur' , pattern:/^[0-9]+(.[0-9]{2})?$/ }
                ],
                remark : [
                { required: true, message: '请输入备注', trigger: 'blur' }
                ],
                fatherId: [
                { required: true, message: '请选择一级', trigger: 'blur' }
                ],
                num: [
                    { required: true, message: '请输入排序', trigger: 'blur' },
                    {
                        pattern: /^\+?[1-9][0-9]*$/,
                        required: true,
                        message: '请输入正确序号',
                        trigger: 'blur'
                    }
                ],
            },
        }
    },
    components: {
        Pagination
    },
    created(){
        this.getdata()
        this.getUserList()
        this.styleQuery()
    },
    methods:{
        styleChange(e){ 
            for(let item of this.styleList){
                if(e == item.id){
                    this.addDeviceForm.styleName = item.name
                }
            }
        },
        styleQuery(){
            styleList().then(res=>{
                this.styleList = res.data
            })
        },
        systemModeInput(e){
            if(e == 1){
                this.systemModeRange = {
                    systemMode1:false,
                    systemMode2:false,
                    systemMode3:false,
                    systemMode4:false,
                }
                this.systemMode = ''
            }else {
                this.systemModeRange = {
                    systemMode1:true,
                    systemMode2:true,
                    systemMode3:true,
                    systemMode4:true,
                }
            }
        },
        getUserList(){
            storeSelect({
                page:1,
                pageSize:999,
                userType:1,
            }).then(res=>{
                this.storeUsersList = res.data.dataList
            })
        },
        handleClick(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.getdata()
        },
        addDeviceSunmit(form){
            this.$refs[form].validate(valid => {
                if (valid) {
                    if(this.systemModeOperator == ''){
                        this.$message.error('请选择设置设备系统管理权限')
                    }else if(this.systemModeRange.systemMode1 == false && this.systemModeRange.systemMode2 == false && this.systemModeRange.systemMode3 == false && this.systemModeRange.systemMode4 == false){
                        this.$message.error('请选择限制设备只能使用以下系统')
                    }else if(this.systemMode == ''){
                        this.$message.error('请选择设置设备当前的系统')
                    }else {
                        createSaleOrder({
                            distributorId:this.addDeviceForm.distributorId,
                            total:this.addDeviceForm.total,
                            price:this.addDeviceForm.price,
                            remark:this.addDeviceForm.remark,
                            systemMode:this.systemMode,
                            systemModeOperator:this.systemModeOperator,
                            systemModeRange:JSON.stringify(this.systemModeRange),
                            styleId:this.addDeviceForm.styleId,
                            styleName:this.addDeviceForm.styleName
                        }).then(res=>{
                            if(res.success){
                                this.$message.success('创建成功')
                                this.addDeviceForm = {
                                    distributorId:'',
                                    total:'',
                                    price:'',
                                    remark:'',
                                    styleName:'',
                                    styleId:'',
                                }
                                this.editFormVisible = false
                                this.systemModeRange = {
                                    systemMode1:true,
                                    systemMode2:true,
                                    systemMode3:true,
                                    systemMode4:true,
                                }
                                this.systemMode = ''
                                this.systemModeOperator = ''
                                this.getdata()
                            }else {
                                this.$message.error(res.messages)
                            }
                        })
                    }
                } else {
                    return false
                }
            })
        },
        revokeSubmit(){
            if(this.remark == ''){
                this.$message.error("请填写备注")
            }else{
                revokeSaleOrder({
                    id:this.id,
                    revokeRemark:this.remark
                }).then(res=>{
                    if(res.success){
                        this.remark = ''
                        this.$message.success('撤销成功')
                        this.revokeFlag = false
                        this.getdata()
                    }else {
                        this.$message.error(res.messages)
                    }
                })
            }
        },  
        revokeClick(index , row){
            this.remark = ''
            this.revokeFlag = true
            this.id = row.id
        },
        addDeviceClick(){
            if(this.addDeviceForm.machineId == ''){
                this.$message.error('设备sn码不能为空')
            }else{
                let pushFlag = false
                for(let item of this.machineIdList){
                    if(item == this.addDeviceForm.machineId){
                        pushFlag = true
                    }
                }
                if(pushFlag == true){
                    this.$message.error('该设备sn码已添加')
                }else{
                    checkMachineId({
                        machineId:this.addDeviceForm.machineId
                    }).then(res=>{
                        if(res.success){
                            this.machineIdList.push(this.addDeviceForm.machineId)
                            this.addDeviceForm.machineId = ''
                        }else {
                            this.$message.error(res.messages)
                        }
                    })
                }
            }
        },
        deleteClick(index){
            this.machineIdList.splice(index , 1)
        },
        handleEdit(index , row){
            getSaleOrderDetail({
                id:row.id
            }).then(res=>{
                if(res.success){
                    this.detailsFlag = true
                    this.StorageOrder = res.SaleOrder
                }else {
                    this.$message.error(res.messages)
                }
            })
            
        },
        addClick(){
            this.editFormVisible = true
            this.addDeviceForm.machineId = ''
            this.machineIdList = []
        },
        closeDialog(){
            this.editFormVisible = false
        },
        addBanner(){
            this.editFormVisible = true
        },
        empty(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.formInline.name = '' 
            this.getdata()
        },
        search(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.getdata()
        },
        getdata(){
            loadSaleOrderList({
                page:this.formInline.page,
                pageSize:this.formInline.limit,
                status:this.activeName,
                name:this.formInline.name
            }).then(res=>{
                this.listData = res.pageInfo.list
                this.pageparm.total = res.pageInfo.total
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/views/equipmentManagement/salesSlip.vue